module.exports = "<div class=\"ng-img-div\" ng-class=\"divClass\">\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/recruit/src/directive/default-img/default-img.html
// module id = 84
// module chunks = 0 3